import { render, staticRenderFns } from "./EventHistoryTenderCopiedParams.vue?vue&type=template&id=c4a65692"
import script from "./EventHistoryTenderCopiedParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryTenderCopiedParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports